import {
  Component,
  input,
  output,
  OutputEmitterRef,
  Signal,
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { SetUpTwoFactorScreen } from '../set-up-two-factor.component';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'app-set-up-initial',
  imports: [MatButton, MatIcon, TranslateModule, NgOptimizedImage],
  templateUrl: './set-up-initial.component.html',
  styleUrls: [
    '../../login-form/login-form.component.scss',
    '../set-up-two-factor.component.scss',
  ],
})
export class SetUpInitialComponent {
  email: Signal<string> = input();
  dismiss: OutputEmitterRef<void> = output<void>();
  changeScreen: OutputEmitterRef<SetUpTwoFactorScreen> =
    output<SetUpTwoFactorScreen>();

  onDismiss() {
    this.dismiss.emit();
  }

  onSetUp() {
    this.changeScreen.emit(
      this.email()
        ? SetUpTwoFactorScreen.CHOOSE_METHOD
        : SetUpTwoFactorScreen.AUTHENTICATOR_APP,
    );
  }
}
